import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFirebaseAuthIsLoaded } from '../selectors';

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const [isInitializing, setIsInitializing] = useState(true);
  const isAuthLoaded = useSelector(selectFirebaseAuthIsLoaded);

  useEffect(() => {
    if (isAuthLoaded) {
      setIsInitializing(false);
    }
  }, [isAuthLoaded]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};